export const GET_ALL_PIPE_DETAILS = '@@get_All_Pipe_Details';
export const GET_ALL_PIPE_DETAILS_SUCCESS = '@@get_All_Pipe_Details_Success';
export const GET_ALL_PIPE_DETAILS_FAILURE = '@@get_All_Pipe_Details_Failure';
export const CLEAR_ALL_PIPE_DETAILS = '@@clear_All_Pipe_Details';

export const GET_LIST_MANUFACTURING_CATEGORY = '@@get_List_Manufacturing_Category';
export const GET_LIST_MANUFACTURING_CATEGORY_SUCCESS = '@@get_List_Manufacturing_Category_Success';
export const GET_LIST_MANUFACTURING_CATEGORY_FAILURE = '@@get_List_Manufacturing_Category_Failure';

